import './BStripes.css';

/**
 * Diagonal color stripes that add visual interest
 * using mix-blend-mode: multiply
 */
export function BStripes() {
  return (
    <div className="b-stripes" aria-hidden="true">
      <div className="b-stripe b-stripe--green-1" />
      <div className="b-stripe b-stripe--purple" />
      <div className="b-stripe b-stripe--green-2" />
    </div>
  );
}
